import { allMedicalConditions } from 'constants/constants';

export const getPreferenceKey = (conditionValue: string, diabetesValue = '1') => {
  switch (conditionValue) {
    case 'bpTreated':
      return 'hypertensionKey';
    case 'diabetesType':
      if (diabetesValue === '2') return 'diabetesType2Key';
      if (diabetesValue === '3') return 'diabetesGestationalKey';
      else return 'diabetesType1Key';
    case 'asthmaDiagnosed':
      return 'asthmaKey';
    case 'copdDiagnosed':
      return 'COPDKey';
    case 'CHFDiagnosed':
      return 'CHFKey';
    case 'IBDDiagnosed':
      return 'IBDDiagnosedTitleKey';
    case 'is_pregnant':
      return 'pregnancyKey';
    case 'preeclampsia':
      return 'conditionPreeclampsia';
    default: {
      // Fallback: a raw ICD code (e.g. 'I10') resolves to its description key ('hypertensionKey')
      // so it matches the condition dropdown option values built from allMedicalConditions.
      const byIcdCode = allMedicalConditions.find((cond) => cond.code === conditionValue);
      return byIcdCode?.description ?? conditionValue;
    }
  }
};

export const getCondition = (conditionLabel: string | null, intl: any) => {
  switch (conditionLabel) {
    case intl.formatMessage({ id: 'hypertensionKey' }):
      return 'hypertensionKey';
    case intl.formatMessage({ id: 'diabetesType1Key' }):
      return 'diabetesType1Key';
    case intl.formatMessage({ id: 'diabetesType2Key' }):
      return 'diabetesType2Key';
    case intl.formatMessage({ id: 'diabetesGestationalKey' }):
      return 'diabetesGestationalKey';
    case intl.formatMessage({ id: 'asthmaKey' }):
      return 'asthmaKey';
    case intl.formatMessage({ id: 'COPDKey' }):
      return 'COPDKey';
    case intl.formatMessage({ id: 'CHFKey' }):
      return 'CHFKey';
    case intl.formatMessage({ id: 'IBDDiagnosedTitleKey' }):
      return 'IBDDiagnosedTitleKey';
    case intl.formatMessage({ id: 'pregnancyKey' }):
      return 'pregnancyKey';
    case intl.formatMessage({ id: 'conditionPreeclampsia' }):
      return 'conditionPreeclampsia';
    case intl.formatMessage({ id: 'pregnancyHypertension' }):
      return 'pregnancyHypertension';
    case intl.formatMessage({ id: 'sleMedicalCondition' }):
      return 'sleMedicalCondition';
    case intl.formatMessage({ id: 'kidneyDisease' }):
      return 'kidneyDisease';
    default:
      return '';
  }
};
export const getPreference = (conditionKey: string) => {
  switch (conditionKey) {
    case 'hypertensionKey':
      return 'bpTreated';
    case 'diabetesType1Key':
    case 'diabetesType2Key':
    case 'diabetesGestationalKey':
      return 'diabetesType';
    case 'asthmaKey':
      return 'asthmaDiagnosed';
    case 'COPDKey':
      return 'copdDiagnosed';
    case 'CHFKey':
      return 'CHFDiagnosed';
    case 'IBDDiagnosedTitleKey':
      return 'IBDDiagnosed';
    case 'pregnancyKey':
      return 'is_pregnant';
    case 'conditionPreeclampsia':
      return 'preeclampsia';
    default:
      return conditionKey;
  }
};

export const getConditionValue = (condition: string | null, intl: any) => {
  switch (condition) {
    case 'diabetesType2Key':
      return '2';
    case 'diabetesGestationalKey':
      return '3';
    default:
      return '1';
  }
};

export const formatPatientConditions = (conditions: ICondition[], intl: any) => {
  const patientConditions: ISelectOption[] = [];
  conditions.map((condition) => {
    if (condition.condition !== '') {
      const label = intl.formatMessage({ id: condition.condition });
      const conditionOption: ISelectOption = {
        label: label,
        value: condition.condition,
        color: '#dee2e6'
      };
      patientConditions.push(conditionOption);
    }
  });
  return patientConditions;
};

export const getRPMReason = (preference: string, allConditions: any[]) => {
  let condition = '';
  // if condition is diabetesType, check all patient conditions to find diabetes type value (1, 2, 3)
  if (preference === 'diabetesType') {
    const diabetes = allConditions.find((cond) => cond['diabetesType'] !== undefined);
    const value = diabetes?.diabetesType;
    condition = getPreferenceKey(preference, value);
  } else {
    condition = getPreferenceKey(preference);
  }
  return { condition: condition };
};
